const AwardIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="27"
      height="40"
      viewBox="0 0 27 40"
      fill="none"
      stroke="white"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.01602 23.15L4.99935 38.3333L13.3327 33.3333L21.666 38.3333L19.6493 23.1333M24.9993 13.3333C24.9993 19.7766 19.776 25 13.3327 25C6.88936 25 1.66602 19.7766 1.66602 13.3333C1.66602 6.88997 6.88936 1.66663 13.3327 1.66663C19.776 1.66663 24.9993 6.88997 24.9993 13.3333Z"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AwardIcon
